import React from "react";
import { Card, CardBody } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";

function formatTruncMsg(msgData) {
  try {
    return msgData.substr(0, 10) + "...";
  } catch (err) {
    return "-";
  }
}

function formatSqlDate(sqlDate) {
  if (!sqlDate) return null;
  return moment(sqlDate).format("MMM DD YYYY h:mm:ss a");
}

function formatVoiceCallResult(result_int) {
  switch (result_int) {
    case 3:
    case 5:
      return "Live Answer";
    case 4:
      return "Answering Machine";
    case 7:
      return "Busy";
    case 10:
    case 48:
      return "No Answer";
    default:
      return "OTHER";
  }
}

export const expandMessageRow = {
  onlyOneExpanding: true,
  renderer: (row) => (
    <div>
      <ol>
        <li>
          <span className="input-group-text">
            <u>MbId</u>
          </span>
          <p>{row.mbid_ch}</p>
        </li>
        <li>
          <span className="input-group-text">
            <u>Alternate Channel</u>
          </span>
          <p>{row.alt_channel}</p>
        </li>
        <li>
          <span className="input-group-text">
            <u>Params</u>
          </span>
          <p>{row.params_vch}</p>
        </li>
        <li>
          <span className="input-group-text">
            <u>Error Message</u>
          </span>
          <p>{row.error_message}</p>
        </li>
      </ol>
    </div>
  ),
};

export const expandVoiceSmsEmailRow = function (type) {
  return {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <ol>
          <li>
            <span className="input-group-text">
              <u>{type === "disposition" ? "Additional Info" : "Error Message"}</u>
            </span>
            <p>{type === "disposition" ? row.additionalInfo || "-" : row.error_message || "-"}</p>
          </li>
          {type === "disposition" ? (
            <li>
              <span className="input-group-text">
                <u>File FTP Date (UTC)</u>
              </span>
              <p>{formatSqlDate(row.file_created_dt)}</p>
            </li>
          ) : (
            ""
          )}
        </ol>
      </div>
    ),
  };
};

//Default Sorting
export const defaultLookupSort = (tableName) => {
  if (tableName !== "voice")
    return [
      {
        dataField: "created_at_utc",
        order: "asc",
      },
    ];

  return [
    {
      dataField: "created_dt",
      order: "asc",
    },
  ];
};

//Function to draw
export const messageTableSchema = [
  {
    dataField: "id",
    text: "Message Id",
    hidden: true,
  },
  {
    dataField: "mbid_ch",
    text: "Message Id",
    hidden: true,
  },
  {
    dataField: "type_vch",
    text: "Type",
    sort: true,
  },
  {
    dataField: "subtype_vch",
    text: "SubType",
    sort: true,
  },
  {
    dataField: "companyCode_vch",
    text: "Company",
    sort: true,
  },
  {
    dataField: "accountNumber_vch",
    text: "Account Number",
    sort: true,
  },
  {
    dataField: "error_message",
    text: "Error Message",
    sort: true,
    formatter: (errMsg) => formatTruncMsg(errMsg),
  },
  {
    dataField: "created_at_utc",
    text: "Created At(UTC)",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
];

export const emailTableSchema = [
  {
    dataField: "emailevent_id_bint",
    text: "EMAIL_KEY_ID",
    sort: false,
    hidden: true,
  },
  {
    dataField: "email_vch", //sg_email_vch
    text: "Email",
    sort: true,
  },
  {
    dataField: "sg_event_vch",
    text: "Status",
    sort: true,
  },
  {
    dataField: "sg_timestamp_dt",
    text: "Status Date",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
  {
    dataField: "error_message",
    text: "Error",
    sort: true,
    formatter: (errMsg) => formatTruncMsg(errMsg),
  },
];
export const smsTableSchema = [
  {
    dataField: "smsresults_id_bint",
    text: "SMS_KEY_ID",
    sort: false,
    hidden: true,
  },
  {
    dataField: "recipient_vch", //sinch_recipient
    text: "SMS No.",
    sort: true,
  },
  {
    dataField: "sinch_status_vch",
    text: "SMS Status",
    sort: true,
  },
  {
    dataField: "sinch_status_dt",
    text: "Status Date",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
  {
    dataField: "error_message",
    text: "Error",
    sort: true,
    formatter: (errMsg) => formatTruncMsg(errMsg),
  },
];

export const voiceTableSchema = [
  {
    dataField: "voicesent_id_bint",
    text: "Voice Id",
    hidden: true,
  },
  {
    dataField: "phone_vch", //DialString_vch
    text: "Dialled",
    sort: true,
  },
  {
    dataField: "CallResult_int",
    text: "Call Result",
    sort: true,
    formatter: (result) => formatVoiceCallResult(result),
  },
  {
    dataField: "CallStartTime_dt",
    text: "Start Time",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
  {
    dataField: "CallEndTime_dt",
    text: "End Time",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
  {
    dataField: "DialerName_vch",
    text: "Dialer Name",
    sort: true,
  },
  {
    dataField: "error_message",
    text: "Error",
    sort: true,
    formatter: (errMsg) => formatTruncMsg(errMsg),
  },
];

// pref_timestamp_dt, created_at, updated_at, unique_id
export const preferenceTableSchema = [
  {
    dataField: "id",
    text: "Voice Id",
    hidden: true,
  },
  {
    dataField: "accountnumber_int",
    text: "Account",
    sort: true,
  },
  {
    dataField: "eventtype_vch",
    text: "Type",
    sort: true,
  },
  {
    dataField: "subeventtype_vch",
    text: "Sub Type",
    sort: true,
  },
  {
    dataField: "contact_channel_vch",
    text: "Channel",
  },
  {
    dataField: "contact_string_vch",
    text: "Contact",
    sort: true,
  },
  {
    dataField: "dnd_starttime_vch",
    text: "DND Start Time",
    sort: true,
  },
  {
    dataField: "dnd_endtime_vch",
    text: "DND End Time",
    sort: true,
  },
];

export const dispositionTableSchema = [
  {
    dataField: "file_name",
    text: "File Name (UTC Time)",
  },
  {
    dataField: "amerenId",
    text: "Ameren Id",
  },
  {
    dataField: "channel",
    text: "Channel",
  },
  {
    dataField: "accountNumber",
    text: "Account Number",
  },
  {
    dataField: "contactString",
    text: "Contact",
  },
  {
    dataField: "status_vch",
    text: "Status",
  },
  {
    dataField: "recordTimeStamp",
    text: "Date Time",
    sort: true,
    formatter: (dt) => formatSqlDate(dt),
  },
];

export const MbIdDrawLookUpTable = (data, keyField, tableSchema, defaultSorted) => (
  <Card>
    <CardBody>
      <BootstrapTable
        bootstrap4
        hover
        classes="table-responsive-md"
        keyField={keyField}
        data={data ? data : []}
        columns={tableSchema}
        bordered={false}
        defaultSorted={defaultSorted}
      />
    </CardBody>
  </Card>
);
